<div class="feature-metadata-container">
  <mat-expansion-panel hideToggle>
    <mat-expansion-panel-header>
      <mat-panel-title>Feature Information</mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div class="container">
        <div class="grid-section">
          <div class="grid-content">
            <h4>Feature Identifier</h4>
            <p>{{ selectedTimeSlice().featureIdentifier }}</p>
          </div>
          <div class="grid-content">
            <h4>Feature Name</h4>
            <p>{{ selectedTimeSlice().featureName }}</p>
          </div>
        </div>
        <div class="metadata-drawer">
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>Timeslice Information</mat-panel-title>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              <div class="container">
                <div class="grid-section">
                  <div class="grid-content">
                    <h4>Resource Title</h4>
                    <p>{{ selectedTimeSlice()?.resourceTitle || "-" }}</p>
                  </div>
                </div>
                <div class="grid-section">
                  <div class="grid-content">
                    <h4>Creation Date</h4>
                    <p>{{ selectedTimeSlice()?.creationDate | dateTz : "DD MMM YYYY HH:mm z" : 'UTC' | uppercase }}</p>
                  </div>
                  <div class="grid-content">
                    <h4>Revision Date</h4>
                    <p>{{ (selectedTimeSlice()?.revisionDate | dateTz : "DD MMM YYYY HH:mm z" : 'UTC') || "-" }}</p>
                  </div>

                  <div class="grid-content">
                    <h4>Feature Lifetime</h4>
                    <p>
                      {{ selectedTimeSlice().start | dateTz : "DD MMM YYYY HH:mm z" : 'UTC' | uppercase }} to
                      <span
                        matTooltip="Until Further Notice"
                        [matTooltipDisabled]="!!selectedTimeSlice().end"
                        >{{ (selectedTimeSlice()?.end | dateTz : "DD MMM YYYY HH:mm z" : 'UTC' | uppercase) || "UFN" }}
                      </span>
                    </p>
                  </div>
                </div>

                <div class="grid-section">
                  <div class="grid-content">
                    <h4>Timeslice Interpretation</h4>
                    <p>{{ selectedTimeSlice().interpretation }}</p>
                  </div>
                  <div class="grid-content">
                    <h4>Sequence Number</h4>
                    <p>{{ selectedTimeSlice().sequenceNumber }}</p>
                  </div>
                  <div class="grid-content">
                    <h4>Correction Number</h4>
                    <p>{{ selectedTimeSlice().correctionNumber }}</p>
                  </div>
                </div>

                <div class="grid-section">
                  <div class="grid-content">
                    <h4>Originator Organisation</h4>
                    <p>{{ selectedTimeSlice()?.originatorOrganisation || '-' }}</p>
                  </div>
                  <div class="grid-content">
                    <h4>Data Provider Organisation</h4>
                    <p>{{ (selectedTimeSlice()?.dataProviderOrganisation) || '-' }}</p>
                  </div>
                  <div class="grid-content">
                    <h4>Data Provider Username</h4>
                    <p>{{ (selectedTimeSlice().dataProviderUsername) || '-' }}</p>
                  </div>
                </div>
              </div>
            </ng-template>
          </mat-expansion-panel>
        </div>
      </div>
    </ng-template>
  </mat-expansion-panel>
</div>
